import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import Skeleton from '@material-ui/lab/Skeleton';
import Item from './Item';
import HomeBoxHeading from './HomeBoxHeading';
import { Restaurant } from '../../utils';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface Props {
  restaurants: Restaurant[];
  title?: string;
  subTitle?: string;
  iconLink?: string;
  loading?: boolean;
}

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  row: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
      },
    },
  ],
};

const WrapItem = styled.div`
  padding: 0;
`;
const WrapItemContainer = styled.div`
  margin: 0 -10px;
`;
const HomeBox: React.FC<Props> = (props) => {
  const { restaurants, title, subTitle, iconLink } = props;
  return (
    <div
      className="content-box-new"
      style={{ marginBottom: '15px', padding: '16px 16px 20px 16px' }}
    >
      <HomeBoxHeading icon={iconLink} title={title || ''} desc={subTitle || ''} />
      <WrapItemContainer>
        <Slider {...settings}>
          {restaurants.length
            ? restaurants.map((item: any) => (
                <WrapItem key={item}>
                  <Item {...item} />
                </WrapItem>
              ))
            : [1, 2, 3, 4].map((item, index) => {
                return (
                  <div>
                    <Skeleton variant="rect" height={200} />
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                  </div>
                );
              })}
        </Slider>
      </WrapItemContainer>
    </div>
  );
};

export default HomeBox;
